module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAoCAMAAADT08pnAAAAclBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACa4vOeAAAAJXRSTlMA+O/j1sWbg2g8LR0Ssgno3NvNx7unnpF4bGFWUlFMQSkiFg0GlDsRBwAAAKBJREFUKM+F00cSxSAMA9AAKaT+3vtPuP8VY1beyCO2byZBxipiOHwKdHxK7oHgnOTckNRZGiRNlhpJzDJOQF5OpBqAtF6k7IF0QSR8gfSliG+BDJWIewOZxix3M+rVjHoxo54WIE8ncpytqPu/FXX7s6JuOivqjgD9lP6cXJcH1JHwIerYyUPRp9VlwOtDFo6vqC41r4EWh1eNlzN6XOcVqB4Y5hvyOfAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/right.png
// module id = E3OR
// module chunks = 104